import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// `withCredentials: true` tells the browser to send the HTTP-only
// `vs_token` cookie planted by /api/auth/verify-otp on every request.
// This is the primary auth carrier now — a compromised JS context (XSS,
// buggy 3rd-party lib) can no longer read the token.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Legacy fallback: if a browser tab is still running a build that stored
// the token in localStorage (from the pre-cookie release), keep sending
// the Bearer header so nothing breaks mid-session. After one clean login
// the cookie takes over and this branch becomes a no-op.
api.interceptors.request.use((config) => {
  const legacy = localStorage.getItem("vs_token");
  if (legacy && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${legacy}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // eslint-disable-next-line no-console
      console.warn("401 – session expired");
    }
    return Promise.reject(err);
  }
);

// Kept for legacy call-sites that build direct <a href> download URLs.
// With the cookie in place the `?auth=` query param is no longer needed
// for same-origin requests; we omit it entirely.
export function fileUrl(storagePath) {
  return `${API_BASE}/files/${storagePath}`;
}
